// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"cardTitle-f01147eb"};